import {gql} from '@apollo/client';

import {doQuerySafe} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {RequestTemplateQuery, RequestTemplateQueryVariables} from './__generated/RequestTemplateQuery';

export const REQUEST_TEMPLATE_QUERY = gql`
  query RequestTemplateQuery($id: StrictString!) @skipAudit @engComponent(name: REQUESTS) {
    requestTemplate(id: $id) {
      ... on RequestTemplateNode {
        id
        templateSpecJson
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

type RequestTemplateWithSpecGraphQL = ExtractByTypename<
  RequestTemplateQuery['requestTemplate'],
  'RequestTemplateNode'
>;

export default async function doRequestTemplateQuery(
  id: string
): Promise<RequestTemplateWithSpecGraphQL | null> {
  const result = await doQuerySafe<RequestTemplateQuery, RequestTemplateQueryVariables>(
    {query: REQUEST_TEMPLATE_QUERY},
    {variables: {id}}
  );

  const {requestTemplate} = result;
  return isInaccessible(requestTemplate) ? null : requestTemplate;
}
